import * as ACTION_TYPES from './types';

export function getClinicsOfDoctor(doctorId) {
  return {
    types: [
      ACTION_TYPES.CLINIC_GET_REQUESTED,
      ACTION_TYPES.CLINIC_GET_SUCCEED,
      ACTION_TYPES.CLINIC_GET_FAILED,
    ],
    promise: client => client.get(`/doctors/${doctorId}/clinics`),
    options: {
      clientName: 'iam',
    },
  };
}
